import { render, staticRenderFns } from "./FullRow.vue?vue&type=template&id=08428aec"
import script from "./FullRow.vue?vue&type=script&lang=ts"
export * from "./FullRow.vue?vue&type=script&lang=ts"
import style0 from "./FullRow.vue?vue&type=style&index=0&id=08428aec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports